import { render } from "./fueltransfer.vue?vue&type=template&id=7c21dcc1"
import script from "./fueltransfer.vue?vue&type=script&lang=js"
export * from "./fueltransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__